module.exports = __webpack_public_path__ + "img/process_3.54afe3ce.png";